import { M3PDinamByActividad } from "./m3-pdinam-by-actividad";

export class M3PRecepcion{
    public IdRecepcion:number;
    public IdEnc:number;
    public Cantidad:number;
    public Fecha:Date;    
    public M3PDinamByActividad = new Array<M3PDinamByActividad>();
    public Estado: string;
}